/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import { entitySchema } from '@bingads-webui-campaign/auction-insight-service';
import { getCampaignAdgroupSelectorFilterConfig } from '@bingads-webui-campaign-react/campaign-adgroup-selector-filter';

import { updateDisplayDomainSchema } from './schema-processors';

export function getFilterConfig({
  scope = {},
  dataService,
  campaignType,
  featureName,
  existingCampaignFilter,
  sessionStore,
  preferenceStoreFactory,
  cacheService,
  dataContextManager,
  edmCampaign,
  jsdata,
  i18n,
  permissions,
  customizedGenerateSchemaForAdGroupProperty,
  customizedGenerateSchemaForCampaignProperty,
  generateSchemaForAccountProperty,
  preferenceService,
}) {
  const customizedSchemaForProcessor = updateDisplayDomainSchema({
    dataService, campaignType, i18n, permissions,
  });

  return getCampaignAdgroupSelectorFilterConfig({
    scope,
    entitySchema,
    featureName,
    i18n,
    sessionStore,
    preferenceStoreFactory,
    customizedSchemaForProcessor,
    cacheService,
    dataContextManager,
    edmCampaign,
    jsdata,
    existingCampaignFilter,
    customizedGenerateSchemaForAdGroupProperty,
    customizedGenerateSchemaForCampaignProperty,
    generateSchemaForAccountProperty,
    preferenceService,
  });
}
